import {useQuery} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config";
import {ApiHookProps} from '@/@types/api.types';
import {GetApartmentDetailsResponseDto} from '@/features/apartments/types/apartments-dto';
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";
import {useCurrencyStore} from "@/store/useCurrencyStore.ts";

type Props = {} & ApiHookProps;

export const useApartmentDetailsApi = ({id}: Props) => {
    const axiosInstance = useAxiosAuth();
    const {currentCurrency} = useCurrencyStore();

    const {
        data: apartmentDetailsData,
        isLoading: isLoadingApartmentDetailsData,
        isError: isErrorApartmentDetailsData
    } = useQuery({
        queryKey: [ApiConfig.queries.features.apartments.queryKeys.details, id, currentCurrency],
        queryFn: async (): Promise<GetApartmentDetailsResponseDto> => {
            const url = `${ApiConfig.queries.features.apartments.endpoints.get}/${id}`;
            const {data} = await axiosInstance.get<GetApartmentDetailsResponseDto>(url);
            return data;
        },
        enabled: !!id,
    });

    return {
        apartmentDetailsData,
        isLoadingApartmentDetailsData,
        isErrorApartmentDetailsData,
    }
}